function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useRef, useState } from 'react';
import { useUnmountedRef } from 'ahooks';
import { useSpring, animated } from '@react-spring/web';
import { useLockScroll } from '../../utils/use-lock-scroll';
import { renderToContainer } from '../../utils/render-to-container';
import { ShouldRender } from '../../utils/should-render';
import cx from 'classnames';
var classPrefix = 'tc-mask';

var Mask = function Mask(props) {
  var className = props.className,
      children = props.children,
      onMaskClick = props.onMaskClick,
      visible = props.visible,
      style = props.style,
      _props$center = props.center,
      center = _props$center === void 0 ? false : _props$center,
      _props$getContainer = props.getContainer,
      getContainer = _props$getContainer === void 0 ? null : _props$getContainer,
      forceRender = props.forceRender,
      _props$disableBodyScr = props.disableBodyScroll,
      disableBodyScroll = _props$disableBodyScr === void 0 ? true : _props$disableBodyScr,
      _props$destroyOnClose = props.destroyOnClose,
      destroyOnClose = _props$destroyOnClose === void 0 ? false : _props$destroyOnClose;

  var _useState = useState(visible),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var unmountedRef = useUnmountedRef();
  var ref = useRef(null);
  useLockScroll(ref, visible && disableBodyScroll);

  var _useSpring = useSpring({
    opacity: visible ? 1 : 0,
    config: {
      precision: 0.01,
      mass: 1,
      tension: 250,
      friction: 30,
      clamp: true
    },
    onStart: function onStart() {
      setActive(true);
    },
    onRest: function onRest() {
      if (unmountedRef.current) return;
      setActive(visible);
    }
  }),
      opacity = _useSpring.opacity;

  var baseProps = {
    className: cx(classPrefix, className, _defineProperty({}, "".concat(classPrefix, "-center"), center)),
    style: Object.assign(Object.assign({}, style), {
      opacity: opacity,
      display: active ? undefined : 'none'
    }),
    onClick: function onClick(e) {
      if (e.target === e.currentTarget) {
        onMaskClick === null || onMaskClick === void 0 ? void 0 : onMaskClick(e);
      }
    }
  };
  var node = /*#__PURE__*/React.createElement(animated.div, Object.assign({}, baseProps), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-content")
  }, children));
  return /*#__PURE__*/React.createElement(ShouldRender, {
    active: active,
    forceRender: forceRender,
    destroyOnClose: destroyOnClose
  }, renderToContainer(getContainer, node));
};

Mask.defaultProps = {
  disableBodyScroll: true,
  center: false,
  forceRender: false,
  destroyOnClose: false
};
export default Mask;